import { Component, computed, effect, inject, input } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { rxResource } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { VisitAddFacade } from '@beautyapp/shared';

@Component({
  selector: 'beautyapp-ehr-list',
  imports: [
    NzButtonModule,
    NzIconModule,
    NzDropDownModule,
    NzMenuModule,
    NzSpinComponent,
  ],
  templateUrl: './ehr-list.component.html',
  styleUrl: './ehr-list.component.scss'
})
export class EhrListComponent {
  private visitAddFacade = inject(VisitAddFacade);

  visitId = input.required<number>();
  reload = input<number | null>();

  readonly ehrTypes = [
    { key: 'ambulatoryCard', route: '/ehealth/ambulatory-card/new', icon: 'file-text', label: 'ამბულატორიული ბარათი' },
    { key: 'smallAmbulatoryCard', route: '/ehealth/small-ambulatory-card/new', icon: 'file', label: 'მცირე ამბულატორიული ბარათი' },
    { key: 'objectiveExaminations', route: '/ehealth/objective-examinations/new', icon: 'form', label: 'ობიექტური გამოკვლევები' },
    { key: 'medicalIntervention', route: '/ehealth/medical-intervention-protocol/new', icon: 'medicine-box', label: 'ჩარევის ოქმი' },
  ] as const;

  constructor() {
    effect(() => {
      if (this.reload()) {
        this.bookingResource.reload();
      }
    });
  }

  bookingResource = rxResource({
    params: () => ({ visitId: this.visitId() }),
    stream: ({ params }) => this.visitAddFacade.getBookings(params.visitId).pipe(
      catchError(() => of([]))
    )
  });

  bookings = computed(() => this.bookingResource.value() || []);

  navigateToEhr(booking: any, route: string) {
    window.open(`${route}/${booking.id}`, '_blank');
  }
}
